export default __webpack_public_path__ + "static/media/srt-icon.2032ec24.svg";